<!--
 * @Description: 
 * @Author: yangsibo
 * @Date: 2023-02-07 11:07:36
 * @LastEditors: yangsibo
 * @LastEditTime: 2023-02-07 11:07:54
 * @FilePath: /adm.xiangli360.com/src/views/Cooperative/Transfer/index.vue
-->
<template>
  <router-view />
</template>

<script>
  export default {
    name: "CooperativeTransfer",
  };
</script>
